import Http from "@/utils/request.js"

// 登录
export const Login = (data) => {
	return Http.request({
		url: '/stock/user/login',
		method: 'post',
		data
	})
}

// 注册
export const SignUp = (data) => {
	return Http.request({
		url: '/stock/user/register',
		method: 'post',
		data
	})
}

// 忘记密码
export const Forgetpassword = (data) => {
	return Http.request({
		url: '/stock/user/forgetPassword',
		method: 'post',
		data
	})
}